import { useEffect, useState } from 'react';
import { ResponseStatus, buildQueryParams, decorateQueryParamsWithPage, isPageResetRequired, isPaginationEnabled } from '../helpers';
import { initWebApi } from '../services/web-api';
export function useData({
  environment,
  webAPIKey,
  articlesPerPage,
  language,
  order,
  sort,
  currentPage,
  previousPage,
  resetPage,
  filterOptions,
  fetchFunction,
  paginationOptions
}) {
  const [webApiIsInitialized, setWebApiIsInitialized] = useState(false);
  const [entities, setEntities] = useState([]);
  const [totalHits, setTotalHits] = useState(0);
  const [loading, setLoading] = useState(true);
  const [responseStatus, setResponseStatus] = useState(ResponseStatus.ok);
  const {
    search,
    ids,
    region,
    fo,
    category,
    brand,
    label,
    additionalQueryParams,
    campaign_id,
    event_id,
    high_performer,
    is_variant
  } = filterOptions;
  useEffect(() => {
    const queryParams = buildQueryParams({
      search,
      ids,
      order,
      sort,
      region,
      fo,
      is_variant,
      category,
      brand,
      label,
      campaign_id,
      event_id,
      high_performer,
      language,
      additionalQueryParams
    });
    const fetchData = async (queryParams, articlesPerPage, page, environment, webAPIKey) => {
      setLoading(true);
      if (!webApiIsInitialized && environment && webAPIKey) {
        await initWebApi({
          environment,
          webAPIKey
        });
        setWebApiIsInitialized(true);
      }
      const fetchParams = decorateQueryParamsWithPage(queryParams, page, articlesPerPage, paginationOptions);
      const {
        entities,
        totalHits,
        responseStatus
      } = await fetchFunction(fetchParams);
      if (entities && entities.length > 0) {
        setEntities(entities);
        if (totalHits) {
          setTotalHits(totalHits);
        }
      }
      if (responseStatus) {
        setResponseStatus(responseStatus);
      }
      setLoading(false);
    };

    // load the first page if filter options have changed but not the currentPage
    if (isPaginationEnabled(paginationOptions) && isPageResetRequired(currentPage, previousPage) && resetPage) {
      resetPage(); // resetPage will trigger a rerendring which will then trigger the fetchData in this hook
    } else {
      fetchData(queryParams, articlesPerPage, currentPage, environment, webAPIKey);
    }
  }, [environment, webAPIKey, articlesPerPage, currentPage, search, JSON.stringify(ids), order, sort, region, JSON.stringify(fo), is_variant, category, brand, label, campaign_id, event_id, high_performer, language, JSON.stringify(additionalQueryParams)]);
  return {
    entities,
    totalHits,
    loading,
    responseStatus
  };
}